export function getGooglePlaceLatLngFromGeocode(place) {
  return {
    lat: place.geometry.location.lat,
    lng: place.geometry.location.lng,
  }
}

export function toReverseGeocodeApiParams(latLng) {
  return {
    latlng: `${latLng.lat},${latLng.lng}`,
  }
}
